import { StepList } from "./Sidebar/StepList";
import { DisplayMode, useFilterStore } from "./Sidebar/useFilterStore";

export const MobileStepsView = () => {
  const filters = useFilterStore((state) => state.filterBy);

  return <StepList forceDisplayMode={DisplayMode.Pipeline} filters={filters} />;
};
